// vueApps.js
import {createApp} from "vue"
import {apply_is_added, apply_is_fav} from "@/libs/eventBus.ts"

const components = {
    SmartSearch: () => import("@/components/Frontend/SmartSearch.vue"),
    SmartSearchFilters: () => import("@/components/Frontend/SmartSearchFilters.vue"),
    SmartSearchResults: () => import("@/components/Frontend/SmartSearchResults.vue"),
    BoxCallAction: () => import("@/components/Frontend/BoxCallAction.vue"),
    HeaderBasket: () => import("@/components/Frontend/HeaderBasket.vue"),
    SearchResult: () => import("@/components/Frontend/SearchResult.vue"),
    ContentCard: () => import("@/components/Frontend/ContentCard.vue"),
    PackageCard: () => import("@/components/Frontend/PackageCard.vue"),
    LoginForm: () => import("@/components/Frontend/LoginForm.vue")
}

export function initDeferredVueApps(pinia, elements) {
    if (elements.app && elements.app.querySelector(".search-page")) {
        initSearchPageApp(pinia)
    } else {
        initHeaderVueApp(pinia)
    }
}

export function initSearchPageApp(pinia) {
    initHeaderVueApp(pinia)
    const SearchApp = createApp({})
    SearchApp.config.compilerOptions.whitespace = "preserve"

    SearchApp.component("smart-search-filters", components.SmartSearchFilters)
        .component("smart-search-results", components.SmartSearchResults)
        .component("search-result", components.SearchResult)
        .component("content-card", components.ContentCard)
        .component("package-card", components.PackageCard)

    SearchApp.use(pinia)

    // GET SERCH RESULTS BEFORE MOUNT

    SearchApp.mount("#app")

    apply_is_added()
    apply_is_fav()

    const packageSearchButton = document.getElementById("package_search")
    const contentSearchButton = document.getElementById("content_search")
    const toggleSearchTypeButtons = document.querySelectorAll(".toggle-search-type")

    if (packageSearchButton) {
        packageSearchButton.addEventListener("click", () => {
            window.location.href = window.location.href.replace("/einzelinhalte?", "/gesamtpakete?")
        })
    }

    if (contentSearchButton) {
        contentSearchButton.addEventListener("click", () => {
            window.location.href = window.location.href.replace("/gesamtpakete?", "/einzelinhalte?")
        })
    }

    if (toggleSearchTypeButtons.length > 0) {
        toggleSearchTypeButtons.forEach((button) => {
            button.addEventListener("click", () => {
                if (button.classList.contains("is-active")) {
                    contentSearchButton.click()
                    button.classList.remove("is-active")
                } else {
                    packageSearchButton.click()
                    button.classList.add("is-active")
                }
            })
        })
    }
}

export function initHeaderVueApp(pinia) {
    const VueApp = createApp({})
    VueApp.config.compilerOptions.whitespace = "preserve"
    VueApp.component("smart-search", components.SmartSearch)
        .component("box-call-action", components.BoxCallAction)
        .component("header-basket", components.HeaderBasket)

    VueApp.use(pinia)
    VueApp.mount(".search-app")
}

export function initLoginVueApp(pinia, open = true) {
    const LoginApp = createApp({})
    LoginApp.config.compilerOptions.whitespace = "preserve"
    LoginApp.provide("open", open)
    LoginApp.component("login-form", components.LoginForm)
    LoginApp.use(pinia)
    LoginApp.mount("#login-form-popup")
}
